import * as React from 'react';
import cx from 'classnames';

import Buttons from 'components/Buttons';
import Icon from 'components/Icon';
import RemainingCharactersCount from 'chat/components/FullPageComposer/RemainingCharactersCount';
import Button from 'components/Button';

export type Props = {
  className?: string;
  sendButton: React.ReactElement;
  translateButton: React.ReactElement;
  charactersRemaining: number;
};

const attachButton = (
  <Button level="icon">
    <Icon name="paperclip-stroked" color="black" />
  </Button>
);

const scheduleButton = (
  <Button level="icon">
    <Icon name="clock-stroked" color="black" />
  </Button>
);

export default class VisualComposerFooter extends React.Component<Props> {
  render() {
    const { sendButton, translateButton, charactersRemaining } = this.props;

    const remainingCharactersCount = <RemainingCharactersCount count={charactersRemaining} />;

    return (
      <div className={cx('VisualComposerFooter', this.props.className)}>
        <Buttons className="VisualComposerFooter-icons" margin="medium">
          {attachButton}
          {translateButton}
          {scheduleButton}
        </Buttons>
        <Buttons>
          {remainingCharactersCount}
          {sendButton}
        </Buttons>
      </div>
    );
  }
}
